module.exports = __webpack_public_path__ + "static/media/source-sans-pro-semibold.f3565095.ttf";